module.exports = __webpack_public_path__ + "static/media/1-c.f3dd39e3.png";